var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LineChart',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"loading":_vm.isLoading,"error":_vm.loadError},on:{"retry":_vm.loadProcessCounts}})}
var staticRenderFns = []

export { render, staticRenderFns }